import { CommonAPI, Token } from './common'
import {
  MFAChallengeAuthenticatorTOTPVerifyRequest,
  MFAChallengeAuthenticatorTOTPVerifyResponse,
  MFAChallengeEmailOTPRequest,
  MFAChallengeEmailOTPResponse,
  MFAChallengeEmailOTPRetryRequest,
  MFAChallengeEmailOTPRetryResponse,
  MFAChallengeEmailOTPVerifyRequest,
  MFAChallengeEmailOTPVerifyResponse,
  MFAChallengeLarkOTPRequest,
  MFAChallengeLarkOTPResponse,
  MFAChallengeLarkOTPRetryRequest,
  MFAChallengeLarkOTPRetryResponse,
  MFAChallengeLarkOTPVerifyRequest,
  MFAChallengeSmsOTPRequest,
  MFAChallengeSmsOTPResponse,
  MFAChallengeSmsOTPRetryRequest,
  MFAChallengeSmsOTPRetryResponse,
  MFAChallengeSmsOTPVerifyRequest,
  MFAChallengeSmsOTPVerifyResponse,
  MFAInfoResponse,
  MFARemoveAuthenticatorTOTPRequest,
  MFARegisterAuthenticatorTOTPRequest,
  MFARegisterAuthenticatorTOTPRequestResponse,
  MFARegisterAuthenticatorTOTPSetupRequest,
  MFASetPreferredFactorRequest,
  MFARegisterPasskeyOptionResponse,
  MFARegisterPasskeyVerifyRequest,
  MFARegisterPasskeyVerifyResponse,
  MFAChallengePasskeyOptionResponse,
  MFAChallengePasskeyVerifyRequest,
  MFAChallengePasskeyVerifyResponse,
  MFAPasskeysResponse,
  MFAUpdatePasskeyRequest,
  MFARemovePasskeysRequest,
  MFARegisterRecoveryCodesViewRequest,
  MFARegisterRecoveryCodesViewResponse,
  MFARegisterRecoveryCodesGenerateRequest,
  MFARegisterRecoveryCodesGenerateResponse,
  MFAChallengeRecoveryCodeVerifyRequest,
  MFAChallengeRecoveryCodeVerifyResponse,
  MFARegisterPasskeyOptionRequest,
  MFAToggleRequest,
  MFAChallengeCarroIDApprovalVerify,
  MFAChallengeCarroIDApprovalVerifyResponse,
  MFAChallengeCarroIDApprovalResponse,
  MFAChallengeCarroIDApprovalRequest,
  MFAChallengePasswordVerifyRequest,
  MFAChallengePasswordVerifyResponse
} from './types'

import { baseURL } from './constants'
import { attachDeviceMeta } from './utils'

export class MfaAuthAPI extends CommonAPI {
  constructor(token: Token) {
    super({ baseURL })

    this.filterRequestPayload()
    attachDeviceMeta(this.injectRequest)

    this.updateToken(token)
  }

  public mfaInfoRequest = () => {
    return this.api.get<MFAInfoResponse>('/mfa/info')
  }

  public mfaChallengeCarroIDApprovalRequest = (
    data: MFAChallengeCarroIDApprovalRequest
  ) => {
    return this.api.post<MFAChallengeCarroIDApprovalResponse>(
      '/mfa/challenge/carro_id/request',
      data
    )
  }

  public mfaChallengeCarroIDApprovalVerify = (
    data: MFAChallengeCarroIDApprovalVerify
  ) => {
    return this.api.post<MFAChallengeCarroIDApprovalVerifyResponse>(
      '/mfa/challenge/carro_id/verify',
      data
    )
  }

  public mfaChallengeEmailOTPRequest = (data: MFAChallengeEmailOTPRequest) => {
    return this.api.post<MFAChallengeEmailOTPResponse>(
      '/mfa/challenge/email_otp/request',
      data
    )
  }

  public mfaChallengeEmailOTPRetry = (
    data: MFAChallengeEmailOTPRetryRequest
  ) => {
    return this.api.post<MFAChallengeEmailOTPRetryResponse>(
      '/mfa/challenge/email_otp/retry',
      data
    )
  }

  public mfaChallengeEmailOTPVerify = (
    data: MFAChallengeEmailOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeEmailOTPVerifyResponse>(
      '/mfa/challenge/email_otp/verify',
      data
    )
  }

  public mfaChallengeSmsOTPRequest = (data: MFAChallengeSmsOTPRequest) => {
    return this.api.post<MFAChallengeSmsOTPResponse>(
      '/mfa/challenge/sms_otp/request',
      data
    )
  }

  public mfaChallengeSmsOTPRetry = (data: MFAChallengeSmsOTPRetryRequest) => {
    return this.api.post<MFAChallengeSmsOTPRetryResponse>(
      '/mfa/challenge/sms_otp/retry',
      data
    )
  }

  public mfaChallengeSmsOTPVerify = (data: MFAChallengeSmsOTPVerifyRequest) => {
    return this.api.post<MFAChallengeSmsOTPVerifyResponse>(
      '/mfa/challenge/sms_otp/verify',
      data
    )
  }

  public mfaChallengeLarkOTPRequest = (data: MFAChallengeLarkOTPRequest) => {
    return this.api.post<MFAChallengeLarkOTPResponse>(
      '/mfa/challenge/lark_otp/request',
      data
    )
  }

  public mfaChallengeLarkOTPRetry = (data: MFAChallengeLarkOTPRetryRequest) => {
    return this.api.post<MFAChallengeLarkOTPRetryResponse>(
      '/mfa/challenge/lark_otp/retry',
      data
    )
  }

  public mfaChallengeLarkOTPVerify = (
    data: MFAChallengeLarkOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeSmsOTPVerifyResponse>(
      '/mfa/challenge/lark_otp/verify',
      data
    )
  }

  public mfaChallengeAuthenticatorTOTPVerify = (
    data: MFAChallengeAuthenticatorTOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeAuthenticatorTOTPVerifyResponse>(
      '/mfa/challenge/totp/verify',
      data
    )
  }

  public mfaSetPreferredFactor = ({ type }: MFASetPreferredFactorRequest) => {
    return this.api.put(`/mfa/set-preferred-factor/${type}`)
  }

  public mfaRegisterAuthenticatorTOTPRequest = (
    data: MFARegisterAuthenticatorTOTPRequest
  ) => {
    return this.api.post<MFARegisterAuthenticatorTOTPRequestResponse>(
      '/mfa/register/totp/request',
      data
    )
  }

  public mfaRemoveAuthenticatorTOTP = (
    data: MFARemoveAuthenticatorTOTPRequest
  ) => {
    return this.api.post('/mfa/remove/totp', data)
  }

  public mfaRegisterAuthenticatorTOTPSetup = (
    data: MFARegisterAuthenticatorTOTPSetupRequest
  ) => {
    return this.api.post('/mfa/register/totp/setup', data)
  }

  public mfaRegisterPasskeyOption = (data: MFARegisterPasskeyOptionRequest) => {
    return this.api.post<MFARegisterPasskeyOptionResponse>(
      '/mfa/register/passkey/option',
      {
        ...data,
        server_host: self.origin
      }
    )
  }

  public mfaRegisterPasskeyVerify = (data: MFARegisterPasskeyVerifyRequest) => {
    return this.api.post<MFARegisterPasskeyVerifyResponse>(
      '/mfa/register/passkey/verify',
      data
    )
  }

  public mfaChallengePasskeyOption = () => {
    const data = {
      server_host: self.origin
    }

    return this.api.post<MFAChallengePasskeyOptionResponse>(
      '/mfa/challenge/passkey/option',
      data
    )
  }

  public mfaChallengePasskeyVerify = (
    data: MFAChallengePasskeyVerifyRequest
  ) => {
    return this.api.post<MFAChallengePasskeyVerifyResponse>(
      '/mfa/challenge/passkey/verify',
      data
    )
  }

  public mfaPasskeys = () => {
    return this.api.get<MFAPasskeysResponse>('/mfa/passkeys')
  }

  public mfaUpdatePasskey = ({ id, ...data }: MFAUpdatePasskeyRequest) => {
    return this.api.post(`/mfa/update/passkey/${id}`, data)
  }

  public mfaRemovePasskey = ({ id, ...data }: MFARemovePasskeysRequest) => {
    return this.api.post(`/mfa/remove/passkey/${id}`, data)
  }

  public mfaRegisterRecoveryCodesView = (
    params: MFARegisterRecoveryCodesViewRequest
  ) => {
    return this.api.get<MFARegisterRecoveryCodesViewResponse>(
      '/mfa/register/recovery_code/view',
      { params }
    )
  }

  public mfaRegisterRecoveryCodesGenerate = (
    data: MFARegisterRecoveryCodesGenerateRequest
  ) => {
    return this.api.post<MFARegisterRecoveryCodesGenerateResponse>(
      '/mfa/register/recovery_code/generate',
      data
    )
  }

  public mfaChallengeRecoveryCodeVerify = (
    data: MFAChallengeRecoveryCodeVerifyRequest
  ) => {
    return this.api.post<MFAChallengeRecoveryCodeVerifyResponse>(
      '/mfa/challenge/recovery_code/verify',
      data
    )
  }

  public mfaChallengePasswordVerify = (
    data: MFAChallengePasswordVerifyRequest
  ) => {
    return this.api.post<MFAChallengePasswordVerifyResponse>(
      '/mfa/challenge/password/verify',
      data
    )
  }

  public mfaToggle2FA = (data: MFAToggleRequest) => {
    return this.api.put(`/mfa/toggle-2fa`, data)
  }
}
